import * as React from "react";

// style, design
import BaseTable from "../../Lists/Base/FinalTable/BaseTable";
import columnDefs from "./errandConfigListDefs";

// store, state
import { constants } from "../../../store/apartments";

export default ({
  persistantQuery,
  isBare,
  ignoreLocalStorage,
  tableId,
  onRowClicked,
  checkRowHighlighted,
  onRowSelected,
  onExcludeClicked,
}) => {
  const columns = React.useMemo(
    () => columnDefs({ onExcludeClicked }),
    [persistantQuery, onExcludeClicked]
  );

  const filters = {};
  const badges = {};

  return (
    <BaseTable
      tableId={tableId || "apartments_errand_full_table"}
      title={"Lägenheter"}
      // onRowClickedWithDetail={(obj) =>
      //   detailUrl({
      //     id: obj.id,
      //   })
      // }
      {...{
        isBare,
        ignoreLocalStorage,
        onRowClicked,
        columns,
        persistantQuery,
        badges,
        filters,
        constants,
        checkRowHighlighted,
        onRowSelected,
      }}
    />
  );
};
